import { format, formatDistanceToNowStrict } from 'date-fns';

export interface DocumentSummaryItem {
  rule_key?: string;
  bucket?: string;
  deadline_at?: string;
  days_until?: number;
  invoice_id?: string | null;
  invoice_number?: string | null;
  vendor_name?: string | null;
  amount?: number | null;
  invoice_status?: string | null;
  invoice_match_status?: string | null;
  approval_request_id?: string | null;
  approval_current_step?: number | null;
  ap_posting_id?: string | null;
  ap_posting_status?: string | null;
  ap_posting_approval_status?: string | null;
  org_unit_id?: string | null;
  org_unit_name?: string | null;
}

export interface DocumentSummaryPayload {
  generated_for_date?: string;
  timezone?: string;
  counts?: Record<string, number>;
  summary_scope?: {
    type?: string;
    org_unit_id?: string | null;
  };
  items?: DocumentSummaryItem[];
}

export const formatNotificationTimestamp = (value: string) => {
  const timestamp = new Date(value);
  return `${formatDistanceToNowStrict(timestamp, { addSuffix: true })} • ${format(timestamp, 'MMM d, yyyy HH:mm')}`;
};

export const formatDeadlineBucket = (bucket?: string, daysUntil?: number) => {
  if (!bucket) {
    return 'Upcoming';
  }
  if (bucket === 'overdue') {
    return 'Overdue';
  }
  if (bucket === 'due_today') {
    return 'Due today';
  }
  if (typeof daysUntil === 'number') {
    return daysUntil === 1 ? 'Due in 1 day' : `Due in ${daysUntil} days`;
  }
  return bucket.replace(/_/g, ' ');
};
